import { ReactElement } from 'react';
import { HiOutlineXMark } from 'react-icons/hi2';
import { useSessionColor, SESSION_COLORS } from '../../../../hooks/useSessionColor';

interface SessionColorSectionProps {
  sessionId: string;
}

export default function SessionColorSection({ sessionId }: SessionColorSectionProps): ReactElement {
  const [sessionColor, setSessionColor] = useSessionColor(sessionId);

  return (
    <div className="cr-mt-4 cr-flex cr-flex-wrap cr-items-center cr-gap-3">
      <span className="cr-text-md cr-w-24 cr-shrink-0 cr-font-medium cr-text-blue-900">Color</span>
      <div className="cr-flex cr-gap-2">
        {SESSION_COLORS.map((colorOption) => (
          <button
            key={colorOption.value || 'none'}
            type="button"
            onClick={() => setSessionColor(colorOption.value)}
            className={`cr-h-8 cr-w-8 cr-rounded-full cr-border-2 cr-transition-all cr-duration-200
              ${sessionColor === colorOption.value
                ? 'cr-ring-2 cr-ring-offset-2 cr-ring-blue-900 cr-border-blue-900'
                : 'cr-border-gray-300 hover:cr-border-gray-400'
              }
              ${colorOption.value === null ? 'cr-bg-white' : ''}
            `}
            style={{
              backgroundColor: colorOption.value ? colorOption.hex : undefined,
            }}
            title={colorOption.label}
          >
            {colorOption.value === null && (
              <HiOutlineXMark className="cr-h-full cr-w-full cr-p-1 cr-text-gray-400" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
